// Dark mode surface shared by the supply chain and Flows graph overlays
export const DARK_SURFACE = '#282424';
